import { atom } from 'recoil'

export const meState = atom({
    key: 'meState',
    default: [],
});